"use client";

import { Employer } from "@entities/employer";
import { DetailItem } from "@shared/ui";

export function GovernmentEmployerLocationDetails({ employer }: { employer: Employer }) {
  if (!employer) return <></>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      <div>
        <DetailItem label="Provinsi" value={employer.village?.sub_district?.city?.province?.name || "-"} />
      </div>
      <div>
        <DetailItem label="Kabupaten/kota" value={employer.village?.sub_district?.city?.name || "-"} />
      </div>
      <div>
        <DetailItem label="Kecamatan" value={employer.village?.sub_district?.name || "-"} />
      </div>
      <div>
        <DetailItem label="Kelurahan" value={employer.village?.name || "-"} />
      </div>
      <div>
        <DetailItem label="Kode Pos" value={employer.postalCode || "-"} />
      </div>
      <div>
        <DetailItem label="Alamat lengkap entitas" value={employer.address || "-"} />
      </div>
    </div>
  );
}
